<template>
  <card-item
    card="item_subscription"
    :tabs="tabs"
    v-model="activeTab"
    :id="`${id}`"
  >
  </card-item>
</template>
<script>
export default {
  methods: {},
  props: ["id"],
  created() {},
  data() {
    return {
      tabs: [
        {
          title: "Подписка",
          key: "subscription",
          component: () => import("./Info"),
        },
        {
          title: "Ошибки",
          key: "errors",
          component: () => import("@/components/Ticket"),
          model: "subscription",
        },
      ],
      activeTab: 0,
    };
  },
};
</script>